<script setup lang="ts">
import {computed,watch,onMounted,onBeforeUnmount} from 'vue';
import {useRoute} from 'vue-router';
import {useSite} from './store';
import Navbar from './components/Navbar.vue';
import Footer from './components/Footer.vue';
import State from './components/State.vue';
const site=useSite();
const route=useRoute(),standalone=computed(()=>Boolean(route.meta.standalone));
async function refresh(){try{await site.refresh();}catch{}}
let updateTimer:ReturnType<typeof setInterval>;
function visible(){if(!standalone.value&&route.matched.length&&document.visibilityState==='visible')void site.checkUpdates();}
watch(()=>route.matched.length>0&&!standalone.value,active=>{if(active){void refresh();void site.checkUpdates();}},{immediate:true});
onMounted(()=>{updateTimer=setInterval(visible,3000);document.addEventListener('visibilitychange',visible);});
onBeforeUnmount(()=>{clearInterval(updateTimer);document.removeEventListener('visibilitychange',visible);});
</script>
<template>
  <RouterView v-if="standalone"/>
  <template v-else><a class="skip-link" href="#main">{{site.text('skip_content')}}</a><template v-if="site.ready"><Navbar/><main id="main" tabindex="-1"><RouterView :key="site.contentRevision"/></main><Footer/></template><State v-else :loading="!site.error" @retry="refresh"/></template>
</template>
